import React, {useState} from "react";
import { destroyAsset, uploadAsset } from "src/actions/community/assetsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewGroupParams } from "src/store/community/assetsSlice";

import DrawerRight from "src/componets/DrawerRight";
import GroupUpload from "src/componets/FileDropzone/GroupUpload";
import communityApi from "src/api/communityApi";
import { Checkbox, message, Radio, RadioChangeEvent, Select } from "antd";
import { EntityId } from "@reduxjs/toolkit";
import { filterOption } from "src/helpers/FormHelper";
import { selectCategoryEntities, selectCategoryIds } from "src/store/community/categoriesSlice";
import { CheckboxValueType } from "antd/es/checkbox/Group";

const Dropzone = () => {
  const dispatch = useAppDispatch();
  const newGroupParams = useAppSelector(state => state.community.assets.newGroupParams);
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);
  const [entity, setEntity] = useState('thumbnail');
  const data: any = { app_id: newGroupParams?.app_id, ...newGroupParams?.options };

  if (newGroupParams?.category_id) {
    data.category_id = newGroupParams?.category_id;
  }

  const options = [
    { label: 'Generate thumbnail from .melmod file?', value: 'mel_mod_opt' }
  ];

  const onChangeOptions = (checkedValues: CheckboxValueType[]) => {
    const optionsParams = {};
    checkedValues.forEach((value: any) => {
      optionsParams[value] = true;
    });

    dispatch(setNewGroupParams({ ...newGroupParams, options: optionsParams }));
  };

  const onChangeUploadEntity = (e: RadioChangeEvent) => {
    setEntity(e.target.value);
  };

  function onClose() {
    dispatch(setNewGroupParams(null));
  }

  function handleUploadSuccess(response: any) {
    dispatch(uploadAsset(response));
  }

  function onClickDestroy(file: any) {
    const id = file.response?.asset?.id;
    if (id) {
      handleDestroy(id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAsset(id));

    if (destroyAsset.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyAsset.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onChangeCategory(value: any) {
    const params = { ...newGroupParams };

    if (value === undefined) {
      delete params.category_id;
    } else {
      params.category_id = value;
    }

    dispatch(setNewGroupParams(params));
  }

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderCategories = () => {
    if (!newGroupParams) {
      return null;
    }

    return (
      <Select
        allowClear
        showSearch
        filterOption={filterOption}
        placeholder='Select a category'
        onChange={onChangeCategory}
        style={{ width: '100%', marginBottom: 20 }}
        defaultValue={newGroupParams.category_id || null}
      >
        {categories && categoryIds.map(renderCategoryOption)}
      </Select>
    )
  }

  return (
    <DrawerRight
      open={!!newGroupParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-newGroup-asset'>
        <h6 className="v-content-label">Assets Dropzone</h6>

        {renderCategories()}

        <GroupUpload
          name={entity}
          action={communityApi.oneSky.url('/onesky/assets')}
          headers={communityApi.oneSky.uploadHeaders}
          data={data}
          onSuccess={handleUploadSuccess}
          listType='picture'
          onRemove={onClickDestroy}
        />

        <h6 className="v-content-label o-sm v-mb-15 v-mt-15">Upload Type</h6>
        <Radio.Group onChange={onChangeUploadEntity} value={entity}>
          <Radio value='thumbnail'>Thumbnail</Radio>
          <Radio value='file'>File</Radio>
        </Radio.Group>

        <h6 className="v-content-label o-sm v-mb-15 v-mt-15">Options</h6>
        <Checkbox.Group options={options} onChange={onChangeOptions} />
      </div>
    </DrawerRight>
  )
}

export default Dropzone;
